/* eslint-disable */
import React, { Component } from 'react'
import { TouchableOpacity, Image, View, Text, ScrollView, FlatList, Dimensions, TextInput, Keyboard } from 'react-native'
import { Images, Fonts } from '../Themes'
import LottieView from 'lottie-react-native'
import { shoppableProductToKargoeItem } from '../Lib/utils.js'
import { SvgBackButton } from './SvgComponent'
import { RecyclerListView, DataProvider, LayoutProvider } from 'recyclerlistview'
import { ImageRecycler } from './ImageRecycler'
import { isIPhoneX } from '../Lib/utils'
import I18n from "i18n-js"

import { KargoeConfig } from '../Config/AppConfig'

const FontColor = 'black'
    , BoldColor = 'black'
    , BaseColor = 'black'
    , Contour = 'white'
    , Highlight = '#4f5271'
    , DarkColor = 'black'
    , ContrastColor = 'white'
    , SearchTagColor = '#4f5271'
    , PlaceholderColor = '#c4c4c4'
    , VerticalLettersBackgroundColor = '#00000000' // clear

let { width : w, height : h } = Dimensions.get('window')
  , regular = { fontFamily : Fonts.style.font.regular, color : FontColor }
  , doublebold = { fontFamily : Fonts.style.font.bold, color : BoldColor }
  , merchantText = { fontFamily : Fonts.style.font.regular, marginTop : -1, color : FontColor }
  , fullScreen = { position : 'absolute', width : w*2, height : h*2, top : -h, left : -w }
  , lettermap = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']

const isIPhone5 = Math.abs(w - 320) < 0.1 // or 5S / SE small screen

    // Search Bubbles in the Query Box
const TagWidth = { Min : w/10, Max : w/3 }
    , TagNumLines = 2
    , TagMargin = 2
    , TagPadding = 8

    // Relative width constraints (0 to 1)
    , ButtonHeight = 30
    , ButtonDelta = 0.4
    , BrandNameDelta = 0.8
    , TitleDelta = 0.75
    , TitleMargin = 15

    // Font Sizes (iOS points)
    , SizeTiny = 9
    , SizeSmall = 10
    , Size = 11
    , SizeMed = 12
    , SizeLarge = 14

    // shopping searchbar plus button (iOS points)
    , PlusButtonWidth = 15
    , PlusButtonColor = 'black'
    , PlusButtonThickness = 5

const MaxProductsFromBrandQuery = 1000
    , SliceSize = 10 // the number of brands in a letter on the scoped out map view

const BrandSortAscending = ( ) => brands => [...brands].sort( (a,b) => a<b? -1: (a>b?1:0) )
const BrandSortDescending = ( ) => brands => [...brands].sort( (a,b) => a>b? 1: (a<b?-1:0) )
const BrandLetterFilter = brands => Letter =>
 brands
 .filter( brand => typeof brand === 'string' && brand.length > 1 && brand[0] === Letter )

let Filter = BrandLetterFilter
  , Order = BrandSortAscending

  , SearchHeadingLayout = { Title : {...doublebold, fontSize : 14, margin : TitleMargin, textAlign : 'center'}
                          , Subject : {...doublebold, fontSize : 14, textAlign : 'center'}
                          , Selector : {...doublebold, fontSize : 12, flexDirection : 'row', alignItems : 'center'}
                          }
  , SearchBarLayout = { borderRadius : 10, borderColor : BaseColor, borderWidth : 1
                      , backgroundColor : ContrastColor, margin : 5, padding : 5
                      , flexDirection : 'row', flexWrap : 'wrap', zIndex : 4, maxWidth : w*0.95
                      , minHeight : w*0.1, alignItems : 'center', justifyContent : 'flex-start'
                      , width : w * 0.85
                      }
  , SearchRow = { flexDirection : 'row', flexWrap : 'nowrap', justifyContent : 'flex-start', alignItems : 'center' }
  , TextInputStyle =  { color : DarkColor, fontSize : SizeMed, paddingLeft : 15, maxWidth : '100%', alignItems : 'center', justifyContent : 'center' }
  , PlusButtonStyle = { flexDirection : 'row', alignItems : 'center', justifyContent : 'flex-end' }
  , TagsColumn =  { flexDirection : 'column', justifyContent : 'center', alignItems : 'center', flexWrap : 'nowrap', maxHeight : w*1/5, maxWidth : w*0.25 }

  , LabelDropdown = { borderRadius : 5, backgroundColor : Contour, borderColor : DarkColor, borderWidth : 1, position : 'absolute', bottom : -45, left : 0, minWidth : w*1/5, maxWidth : w*1/2 }
  , LabelPopupText = { fontSize : SizeMed, color : ContrastColor, textShadowColor : Highlight, textShadowRadius : 1, textShadowOffset : { width : 1, height : 1 }, textAlign : 'left', padding : 15 }
  , ProductSearchLayout = { GridWidth : 2 // search results in rows of two
                          , ProductPadding : 15
                          , DisplayBoxAspectRatio : 1 + 1/3
                          }
  , DefaultProductPictureUri = 'https://s3.amazonaws.com/kargoe-docs/meta-picture-01.jpg'
  , PopupStyle = { }
  , StyleCenter = { flexDirection : 'column', alignItems : 'center', justifyContent : 'center' }


const Tag = props => {
  let popup = props.popup? props.popup: [ ]
  const bgColor = `transparent` // props.Type === 'search'? SearchTagColor: BaseColor
  const textColor = `black` // ContrastColor
  return  <View style={{ zIndex : props.popup? 5: 4 }}>
            <TouchableOpacity activeOpacity={0.5}
              onPress={( ) => props.onPress(props)}
              style={{  backgroundColor : bgColor, borderRadius : 10
                      , minWidth : TagWidth.Min, maxWidth : TagWidth.Max, margin : TagMargin, padding : TagPadding
                      , flexDirection : 'row', flexWrap : 'nowrap', alignItems : 'center', justifyContent : 'space-between' }}>
              <Text style={{ ...regular, fontSize : SizeMed, color : textColor, maxWidth : TagWidth.Max*0.8 }} numberOfLines={TagNumLines}>
                {props.Hash}
              </Text>
              <Text style={{ ...regular, fontSize : SizeMed, color : textColor, maxWidth : TagWidth.Max*0.1, textAlign : 'right', marginLeft : 10 }} numberOfLines={TagNumLines}>
                x
              </Text>
            </TouchableOpacity>
            <View style={{ display : popup.length? 'flex': 'none', ...LabelDropdown, zIndex : 2 }}>
              <TouchableOpacity style={{ ...fullScreen, backgroundColor : '#00000077', zIndex : 1 }} onPress={( ) => props.onShadow(props)} activeOpacity={0.5}/>
              {popup.map( ([PopupQuestion, PopupFunction]) =>
                <TouchableOpacity activeOpacity={0.5} onPress={PopupFunction} style={{ ...PopupStyle, zIndex : 2 }}>
                  <Text style={LabelPopupText} numberOfLines={1}>{PopupQuestion}</Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
}
// A Kargoe Custom style display which shows a Big Letter and a Slice of Brands
let c = str => str.length>1? 'header': str[0]
// letterSuffix is the (15%) thing, may be blank
const LetterSection = props => {
  // console.tron.display({name: 'ExploraShopping', preview: "LetterSection", value: {props}})
  if (props.names.length == 0)
    return null
  const showSeeAll = props.showSeeAll && false
  const brandFontSize = props.isBrandsWithHigher ? SizeLarge : SizeMed
  return (
    <View style={{ padding : 20 }}
      onLayout={ ({ nativeEvent : { layout }}) => {
        if( typeof props.setHeight === 'function' )
          props.setHeight({ [c(props.letter)] : layout.height })
      }}>

      <TouchableOpacity activeOpacity={0.5} onPress={props.onTitle}>
        <View style={{flexDirection: 'row'}}>
            <Text style={[doublebold, {fontSize: isIPhone5 ? 11 : 13, paddingTop: (props.letterSuffix && !isIPhone5) ? 3.5 : 2}]}>
            {props.letter}
            </Text> 
            <Text style={[doublebold, {fontSize: isIPhone5 ? 15 : 17}]}>
            {' '}{props.letterSuffix}
           </Text>    
        </View>
      </TouchableOpacity>

      <FlatList
          data={props.names?props.names:[ ]}
          keyExtractor={ item => item.item }
          renderItem={ item =>
              <TouchableOpacity activeOpacity={0.5}
                  onPress={( )  => props.onPress? props.onPress(item.item): false}>
                <Text style={{ ...regular, fontSize : brandFontSize, margin : 5 }}>{item.item}</Text>
              </TouchableOpacity>
          }/>

      {showSeeAll &&
        <TouchableOpacity activeOpacity={0.5}
            onPress={( )  => props.onPress? props.onPress(false): false}>
          <Text style={{ ...doublebold, fontSize : SizeLarge, marginTop : 10 }}>{I18n.t('explora.seeAll')}</Text>
        </TouchableOpacity>
      }
      {!props.showSeeAll &&
        <TouchableOpacity activeOpacity={0.5} onPress={props.onTitle}>
          <Text style={doublebold}>{I18n.t("explora.backToFull")}</Text>
        </TouchableOpacity>
      }
    </View>
  )
}

const Options = props => {
  var options = [ ]
  if (typeof props.sortOptions != 'undefined') {
    console.log("props.sortOptions keys = " + JSON.stringify(Object.keys(props.sortOptions)))
    for(var Key in props.sortOptions) // sortOptions = { 'Price: Low <- High' : Function.ParentAssignedSort }
      options.push( <TouchableOpacity activeOpacity={0.5} onPress={props.sortOptions[Key]}>
                      <Text style={{...SearchHeadingLayout.Subject, padding : 5 }}>{Key}</Text>
                    </TouchableOpacity> )
  }
  return options
}

const Selector = props =>
  <View>
    <TouchableOpacity
      style={{ flexDirection : 'row', flexWrap : 'wrap', alignItems : 'center' }}
      onPress={props.open} activeOpacity={0.5}>
      {props.children}
      {/* 42x30 natural dim icon */}
      <Image resizeMode='contain' style={{ width : SizeLarge, height : SizeLarge/(42/30), padding : 5 }} source={Images.arrowSelectGradient}/>
    </TouchableOpacity>

    <TouchableOpacity activeOpacity={0.5} onPress={props.close} style={{ ...fullScreen, zIndex : 2, backgroundColor : '#00000077', display : props.show? 'flex': 'none' }}/>

    <View style={{ display : props.show? 'flex': 'none', position : 'absolute', bottom : -125, alignSelf : 'center'
                 , zIndex : 3, backgroundColor : ContrastColor, padding : 5
                 , borderRadius : 14, borderColor : BoldColor, borderWidth : 1 }}>
     {Options(props)}
    </View>
  </View>

const PlusButton = props => {
  let Diameter = props.width? props.width: PlusButtonWidth
    , Color = props.color? props.color: PlusButtonColor
    , Thickness = props.thickness? props.thickness: PlusButtonThickness
  return  <View style={PlusButtonStyle}>
            <View style={{ width : Diameter, height : Diameter, position : 'relative', right : 0 }}>
              <View style={{ width : Thickness, height : Diameter, backgroundColor : Color, position : 'absolute', left : Diameter/2-Thickness/2 }}/>
              <View style={{ width : Diameter, height : Thickness, backgroundColor : Color, position : 'absolute', top : Diameter/2-Thickness/2 }}/>
            </View>
          </View>
}

const SearchProduct = props => {
  let width = w/props.GridWidth
    , height = width / ProductSearchLayout.DisplayBoxAspectRatio
    , fontSizeAlign = (Size, Alignment, Delta) => {
        var fontStyle = {...doublebold, fontSize : Size, textAlign : Alignment}
        if( Delta ) Object.assign(fontStyle, { minWidth : width*Delta, maxWidth : width*Delta })
        return fontStyle
      }
    , fontSize = Size => {return{...doublebold, fontSize : Size}}
    , shopify = props.Product.isShopify === true
    , brand = props.Product[shopify?'Brand':'brand']
    , name = props.Product[shopify?'Title':'name']
    , merchant = props.Product[shopify?'StoreName':'merchant']
    , price = props.Product[shopify?'PriceMax':'price']
  return  <View  style={{ ...props.style, flexDirection : 'column', minWidth : width, maxWidth : width, justifyContent : 'center', alignItems : 'center' }}>
            <TouchableOpacity activeOpacity={0.5} onPress={( ) => props.viewProduct(props.Product)}>
                <ImageRecycler  style={{ width : width, height : height }}
                        source={{ uri : ProductURI(props.Product) }} resizeMode='contain'/>
            </TouchableOpacity>
            <View style={{ padding : 5 }}>
              {/* <Text style={fontSizeAlign(Size,'center',BrandNameDelta)}>{brand}</Text> */}
              <Text style={{fontFamily: Fonts.style.font.bold, fontSize: Size, textAlign: 'center'}}>{brand}</Text>
              <Text style={{ ...fontSizeAlign(SizeSmall,'center',TitleDelta), minHeight : SizeSmall*2+4, maxHeight : SizeSmall*2+8 }} numberOfLines={2}>{name}</Text>
              <Text style={{ textAlign : 'center' }}>{/*This is ironically, strictly inline*/}
                <Text style={fontSize(SizeSmall)}>{I18n.t("explora.soldBy")}</Text>
                <Text style={{...merchantText, fontSize : SizeSmall }}>{merchant}</Text>
              </Text>
              {/* <Text style={fontSizeAlign(SizeMed,'center')}>${price.toFixed(2)}</Text> */}
              <Text style={{fontFamily: Fonts.style.font.regular, fontSize: SizeMed, textAlign: 'center'}}>${price.toFixed(2)}</Text>
            </View>
            <View style={{ flexDirection : 'row', flexWrap : 'nowrap', alignItems : 'center', justifyContent : 'center' }}>
              <TouchableOpacity activeOpacity={0.5}
                  onPress={( ) => props.buyProduct(props.Product)}
                  style={{ borderRadius : SearchBarLayout.borderRadius, borderColor : SearchBarLayout.borderColor, borderWidth : SearchBarLayout.borderWidth, backgroundColor : SearchBarLayout.backgroundColor
                         , minHeight : ButtonHeight, padding : 2, margin : 5, minWidth : width*ButtonDelta, maxWidth : width*ButtonDelta, flexDirection : 'row', justifyContent : 'center', alignItems : 'center' }}>
                <Text style={fontSizeAlign(SizeSmall,'center')}>{I18n.t("explora.buy")}</Text>
              </TouchableOpacity>
              <TouchableOpacity activeOpacity={0.5}
                  onPress={( ) => props.endorseProduct(props.Product)}
                  style={{ borderRadius : SearchBarLayout.borderRadius, borderColor : SearchBarLayout.borderColor, borderWidth : SearchBarLayout.borderWidth, backgroundColor : SearchBarLayout.backgroundColor
                         , minHeight : ButtonHeight, padding : 2, margin : 5, minWidth : width*ButtonDelta, maxWidth : width*ButtonDelta, flexDirection : 'row', justifyContent : 'center', alignItems : 'center' }}>
                <Text style={fontSizeAlign(SizeSmall,'center')}>{I18n.t("explora.endorse")}</Text>
              </TouchableOpacity>
            </View>
          </View>
}
const ProductURI = Product => Product.isShopify? (Product.ImageUrls&&Product.ImageUrls.length?Product.ImageUrls[0]:(Product.ImageUrl?Product.ImageUrl:''))
                                                : Product.image && Product.image.length? Product.image[0]: DefaultProductPictureUri
const SearchResults = props => {
  const { kargoeSearch = false } = props
  let GridWidth = ProductSearchLayout.GridWidth // Right now, 2

    , Products = props.products.reduce(
    ( ProductList, Product, Index ) => {
      ProductList.q.push(Product)
      if( ProductList.q.length >= GridWidth || Index == props.products.length -1 ) {
        ProductList.rows.push(ProductList.q)
        ProductList.q = [ ]
      }
      return ProductList
    }, { q : [ ], rows : [ ] })
  console.tron.display({name: 'SearchResults', preview: "ExploraShopping", value: {propsLayout: props.layout}})
  const height = props.layout.height ? props.layout.height : h - 200 // approx, may go a bit below screen
  return <View style={{ flex : 1, zIndex : 3, minHeight : height, maxHeight : height, minWidth : props.layout.width, maxWidth : props.layout.width }}>
          <View style={{...StyleCenter, zIndex : 3}}>
            <Text style={SearchHeadingLayout.Subject}>{props.products.length} {I18n.t("explora.products")}</Text>
            <Selector style={SearchHeadingLayout.Selector}
                sortOptions={kargoeSearch ? props.kargoeSortOptions : props.sortOptions}
                show={props.showSortSelector( )}
                open={props.openSortSelector}
                close={props.closeSortSelector}>
              <Text style={{ textAlign : 'center' }}>
                <Text style={SearchHeadingLayout.Subject}>{I18n.t("explora.sortBy")}</Text>
                <Text style={SearchHeadingLayout.Subject}>{props.sortOption}</Text>
              </Text>
            </Selector>
          </View>
          <RecyclerListView
            dataProvider={props.parent.recycler.data}
            layoutProvider={props.parent.recycler.layout}
            rowRenderer={(type, Product) => <SearchProduct endorseProduct={props.endorseProduct} buyProduct={props.buyProduct} Type={type} Product={Product} GridWidth={GridWidth} style={{ width : w/GridWidth, backgroundColor : '#ff000000' }} viewProduct={props.viewProduct}/>}
            showsVerticalScrollIndicator={false}
            style={{ zIndex : 1 }}
          />
        </View>
}
// Reduce an \w to first letter, produce a category
const Letters = StringList => lettermap.reduce( (letters,letter) => {
  let filter = Filter(StringList) // use the page declaration filter
    , order = Order( ) // use the page declaration order
  letters[letter] = { brands : filter(letter) } // first filter the input by the brand letter filter
  //const BrandLetterFilter = brands => Letter => brands.filter( brand => typeof brand === 'string' && brand.length > 1 && brand[0] === Letter )

  // apply the ordering function
  letters[letter] . ordered = order(letters[letter].brands)
  // get a small slice of the start of the ordered one
  letters[letter] . sliced = letters[letter].ordered.slice(0,SliceSize-1)
  return letters
}, { })



let TheLetter = props => props.focus&&props.letter&&props.letters&&props.letter!=='header'?(props.letters[props.letter]||{ordered:[]})
                          :(props.letter==='header'&&props.parent.config.shopifyStores.filter( ({StoreId}) => props.parent.config.trendingShopifyStoreIds.indexOf(StoreId) !== -1 ).map(store=>store.StoreName).reduce((li,u)=>{li.ordered.push(u);return li},{ordered:[]}))

const LetterListView = props => {
  // console.tron.log(`LetterListView`)
  return (
    <ScrollView
        ref={ref => { if(ref) {
          props.parent.brandsScroller = ref
          let letter = props.parent.state.letter
            , offsets = props.parent.state.offsets
          if( letter && offsets && offsets[letter] )
            ref.scrollTo({ x : 0, y : offsets[letter], animated : false })
        }}} onScroll={( ) => props.parent.state.letter = false}
        style={{ minWidth : w*0.9, maxWidth : w*0.9 }}>
            <TouchableOpacity activeOpacity={0.5} onPress={( ) => props.setState( { letter:'header',focus:true }, ( ) => props.parent.scrollTo('header') )}>
            <LetterSection order={0} showSeeAll={true}
              setHeight={props.parent.state.setHeaderHeight}
              onTitle={( ) => props.setState({letter:'header',focus:true})}
              letter={props.parent.headerString?props.parent.headerString:'header'} names={props.parent.headerDivs||[ ]}
              letterSuffix={props.parent.headerSuffix?props.parent.headerSuffix:''}
              isBrandsWithHigher={props.parent.headerSuffix ? true: false}
              onPress={name => name? ( ) => { }: props.setState({letter:'header',focus:true}) }/>
           </TouchableOpacity>
           {
            lettermap // lettermap = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
            . map ( (Letter,Index) =>  <TouchableOpacity activeOpacity={0.5} onPress={( ) => props.setState( { letter:Letter,focus:true }, ( ) => props.parent.scrollTo(Letter) )}>
                                        <LetterSection order={Index} showSeeAll={true}
                                          setHeight={props.parent.state.setHeight}
                                          onTitle={( ) => props.setState({letter:Letter,focus:true})}
                                          letter={Letter} names={props.letters[Letter]? props.letters[Letter].sliced: [ ]}
                                          onPress={name => name? props.addFilter('brands',name): props.setState({letter:Letter,focus:true}) }/>
                                       </TouchableOpacity>
                  )
          }
    </ScrollView>
  )
}

const LetterFocusView = props => {
  console.tron.log(`LetterFocusView`)
  return (
    <View>
      <ScrollView style={{ minWidth : w*0.9, maxWidth : w*0.9 }}>
        <LetterSection
            onTitle={( ) => props.setState({ focus : false })}
            letter={props.letter==='header'?props.parent.headerString:props.letter} names={TheLetter(props).ordered}
            onPress={name => props.addFilter(props.letter==='header'?'header':'brands',name) }/>

      </ScrollView>
    </View>
  )
}

const LetterSearchView = props => {
  console.tron.log(`LetterSearchView`)
  let cache = props.parent.state.searchCache[ 'nav,'+props.parent.stateHash( ) ]
    , state = cache? cache: (props.parent.state? props.parent.state: { })
    , hash = v => {
      if( typeof v === 'string' ) return v
      if( !v ) return false
      if( typeof v === 'object' ) {
        if( typeof v.cat_name === 'string' ) return v.cat_name
        if( typeof v.name === 'string' ) return v.name
        if( typeof v.brand === 'string' ) return v.brand
        if( typeof v.color === 'string' ) return v.color
        if( typeof v.merchant === 'string' ) return v.merchant
        if( typeof v.size === 'string' ) return v.size
        if( typeof v.coupon === 'string' ) return v.coupon
      }
      if( typeof v === 'number' ) return v.toFixed(2)
      return false
    }
  const filter = option => // option === 'brands'
    state[option] // this.state.brands [ 'Gucci'0..2000 ]
      ? state[option].map(hash).filter(v => v && v.toLowerCase( ).match(props.search.toLowerCase( )))
      : [ ]
  let search = props.search
    , options = { brands:filter('brands')
                , merchants:filter('merchants')
                , colors:filter('colors')
                , sizes:filter('sizes')
                , categories:filter('categories')
                , coupons:filter('coupons')
                }

    , columns = [[ ],[ ],[ ]]
  if( options.brands.length )
    columns[0].push('brands')
  if( options.merchants.length )
    columns[1].push('merchants')
  if( options.categories.length )
    columns[2].push('categories')

  var next = [ 'sizes', 'colors', 'coupons' ].filter(v=>options[v].length)

  if( options.categories.length < 10 && next.length ) {
    columns[2].push(next[0])
    next.splice(0,1)
  }
  if( options.merchants.length < 10 && next.length ) {
    columns[1].push(next[0])
    next.splice(0,1)
  }
  if( options.brands.length < 10 && next.length ) {
    columns[0].push(next[0])
    next.splice(0,1)
  }

  let display = columns.filter(v => v.length)
  console.log('display: ',display)
  console.log('options: ',options)
  return  <View style={{ flex : 1, flexDirection : 'column', backgroundColor : props.filtering? ContrastColor: '#00000000', borderRadius : 10, borderColor : props.filtering? DarkColor: '#00000000' }}>
            <Text style={doublebold}>{props.search}</Text>
            <View style={{ flex : 1, flexDirection : 'row' }}>
            { display.map( column =>
                <View style={{ flex : 1/display.length, flexDirection : 'column' }}> {
                  column.map( TagType =>
                    <View style={{ flex : 1/column.length, padding : 5 }}>
                      <Text style={{...doublebold, fontSize : SizeMed }}>{TagType}</Text>
                      <FlatList
                          style={ { minWidth : w*1/5, padding : 15, maxWidth : w*0.9*1/column.length, flex : 1
                                  , backgroundColor : ContrastColor, maxHeight : props.layout.height*0.8
                                  , borderColor : 'black', borderRadius : 10, borderWidth : 1
                                  } }
                          data={options[TagType]}
                          keyExtractor={hash}
                          renderItem={ ReactItem => /* Q.E.D {item: "Blank NYC", index: 349, separators: {…}} */
                              <TouchableOpacity activeOpacity={0.5}
                                  onPress={( )  => props.addFilter? props.addFilter( TagType, ReactItem.item ): false}>
                                <Text style={regular}>{hash(ReactItem.item)}</Text>
                              </TouchableOpacity>
                            }/>

                    </View>
                            )
              } </View>   )
            }
            </View>
          </View>
}

const MapView = props => {
  // console.tron.log(`MapView`)
  return (
    <View style={{ flex : 1, flexDirection : 'row', alignItems : 'flex-start', justifyContent : 'flex-start', zIndex : 2 }}>
      { props.filtering || props.search.length > 0
        ? LetterSearchView(props)
        : ( props.focus
          ? LetterFocusView(props)
          : LetterListView(props)
          )
      }
      { KargoeConfig.shoppable.active && props.search.length < 1 && !props.filtering && /* letters down the side */
        <View style={{ backgroundColor : VerticalLettersBackgroundColor, minWidth : w*0.1, maxWidth : w*0.1 }}>
          {
          lettermap // lettermap = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
          . map ( Letter =>  <TouchableOpacity activeOpacity={0.5} onPress={( ) =>
                                props.setState( { focus:props.focus?false:true, letter:Letter }
                                              , ( ) => props.parent.scrollTo(Letter) )}>
                                <Text style={{...doublebold, textAlign : 'center', fontSize : isIPhone5 ? 10 : (isIPhoneX( ) ? 14 : 12)  /*Fonts.size.medium*/ }}>
                                  {Letter}
                                </Text>
                             </TouchableOpacity>
                )
          }
        </View>
      }
    </View>
  )
}


const provider = dataProvider => (name) => dataProvider&&dataProvider[name]? dataProvider[name]: [ ]
export default class ExploraShopping extends Component {
  TagString = Type => this.state.tags[Type].join(',')
  Provider = (TagType, fallback) => provider(this.props.dataProvider)(TagType)
  // note:  sortOption (current) and sortOptions are regen'd in component constructor for language translate
  initialState = ( ) => {return { searchText : ''
                                , actualSearch : ''
                                , showProducts : false
                                , brands : this.Provider('brands')
                                , merchants : this.Provider('merchants')
                                , categories : this.Provider('categories')
                                , sizes : this.Provider('sizes'), colors : this.Provider('colors'), coupons : this.Provider('coupons')
                                , letter : 'header'
                                , layout : { width : w, height : w, x : 0, y : 0 }
                                , searchBarLayout : { width : w, height : w*0.2, x : 0, y : 0 }
                                , focus : false
                                , showSortSelector : false
                                , searchCache : { }
                                , tags :  { brands : [/*Gucci, Levi, ... behavior +tag*/]
                                          , merchants : [ ], colors : [ ], sizes : [ ]
                                          , categories : [ ], coupons : [ ]
                                          }
                                , popup : { }
                                , heights : { }
                                , offsets : false
                                , sortString : 'random' // -last_modified, price, -price, name random
                                , sortOption : 'Best Match'
                                , sortOptions : { 'Price High-Low' : this.sortPriceHighToLow.bind(this, 'Price High-Low')
                                               // , 'Newest' : this.sortNewestFirst.bind(this, 'Newest')
                                               , 'Best Match' : this.sortRandomly.bind(this, 'Random')
                                               //, 'Oldest' : this.sortOldestFirst.bind(this, 'Oldest')
                                               , 'Price Low-High' : this.sortPriceLowToHigh.bind(this, 'Price Low-High')
                                               }
                               , kargoeSortOptions : { 'Price High-Low' : this.sortPriceHighToLow.bind(this, 'Price High-Low')
                                              , 'Best Match' : this.sortRandomly.bind(this, 'Random')
                                              , 'Price Low-High' : this.sortPriceLowToHigh.bind(this, 'Price Low-High')
                                              }
                                , setHeight : h => {
                                    this.setState({ heights : Object.assign({ }, this.state.heights, h) }
                                                  , state => this.computeLetterSectionOffsets.call(this)
                                                  )
                                  }
                                , setHeaderHeight : h => {
                                    this.setState({ heights : Object.assign({ }, this.state.heights, h) }
                                                , state => this.computeLetterSectionOffsets.call(this,'header')
                                                )
                                }
                                , sortHash : ( ) => this.state.sortString
                               }
  }
  //import { RecyclerListView, DataProvider, LayoutProvider } from 'recyclerlistview'
  constructor(props) {
    super(props)
    this.recycler = { index : false, data : new DataProvider((r1,r2)=>r1!==r2), layout : new LayoutProvider(index => index % 2, (type, dim, index) => {dim.width = w/2 ; dim.height = w/1.25}) }
    this.state = this.initialState( )

    /* ref
    "priceHighLow" : "Preço Alto-Baixo",
    "newest" : "O Mais Novo",
    "random": "Aleatório",
    "priceLowHigh" : "Preço Baixo-Alto",
    */

    let priceHighLow = I18n.t("explora.priceHighLow")
    let newest = I18n.t("explora.newest")
    let random = I18n.t("explora.random")
    let priceLowHigh = I18n.t("explora.priceLowHigh")
    let bestMatch = I18n.t("explora.bestMatch") // Best Match

    this.state.sortOptions = {}

    /*
      { priceHighLow : this.sortPriceHighToLow.bind(this, priceHighLow)
                                               , 'NewestY' : this.sortNewestFirst.bind(this, 'NewestY')
                                               , 'RandomY' : this.sortRandomly.bind(this, 'RandomY')
                                               //, 'Oldest' : this.sortOldestFirst.bind(this, 'Oldest')
                                               , 'Price Low-HighY' : this.sortPriceLowToHigh.bind(this, 'Price Low-HighY')
      }
    */

      this.state.sortOption = bestMatch
      this.state.sortOptions[bestMatch] = this.sortRandomly.bind(this, bestMatch)
      this.state.sortOptions[priceHighLow] = this.sortPriceHighToLow.bind(this, priceHighLow)
      // this.state.sortOptions[newest] = this.sortNewestFirst.bind(this, newest)
      // this.state.sortOptions[random] = this.sortRandomly.bind(this, random)
      this.state.sortOptions[priceLowHigh] = this.sortPriceLowToHigh.bind(this, priceLowHigh)

    this.Letters = Letters( this.state.brands )
    this.startSearch = this.startSearch.bind(this)
  }
  componentDidUpdate(previousProps, previousState) {

  }

  resetSearch = ( ) => {
    Object.assign(this.state, { searchText : ''
                              , focus : false, showSortSelector : false
                              , tags :  { brands : [/*Gucci, Levi, ... behavior +tag*/]
                                        , merchants : [ ], colors : [ ], sizes : [ ]
                                        , categories : [ ], coupons : [ ]
                                        }
                              , letter : 'header'
                              , popup : { }
                              })
    this.setState({ redraw : true })
  }

  showSortSelector = ( ) => this.state.showSortSelector
  openSortSelector = ( ) => this.setState({ showSortSelector : true })
  closeSortSelector = ( ) => this.setState({ showSortSelector : false })

  sortBy = (shoppableApiQueryString, sortOptionsKey) => {
    console.log("sortBy " + shoppableApiQueryString + " " + sortOptionsKey)
    this.state.sortString = shoppableApiQueryString
    this.state.sortOption = sortOptionsKey
    this.sendQuery( )
    this.closeSortSelector( )
  }
  sortPriceLowToHigh = sortOptionsKey => this.sortBy('price',sortOptionsKey)
  sortNewestFirst = sortOptionsKey => this.sortBy('-last_modified',sortOptionsKey)
  sortRandomly = sortOptionsKey => this.sortBy('random',sortOptionsKey)
  sortOldestFirst = sortOptionsKey => this.sortBy('last_modified',sortOptionsKey)
  sortPriceHighToLow = sortOptionsKey => this.sortBy('-price',sortOptionsKey)

  unsearch = (Type, Hash) => {
    console.log('unsearch: ',Hash,Type)
    if( Type === 'search' ) {
      this.state.actualSearch = ''
      delete this.state.popup[ `${Type},${Hash}` ]
      this.sendQuery( )
    } else {
      let key = this.state.tags[Type].indexOf(Hash)
      if( key != -1 ) {
        this.state.tags[Type].splice(key,1)
        delete this.state.popup[ `${Type},${Hash}` ]
        this.sendQuery( )
      }
    }

    if( this.numSearchTags( ) < 1 )
      this.resetSearch( )
  }
  onPressTypeTag = (Type, Hash) => {
    /* popup example */
    // this.state.popup[ `${Type},${Hash}` ] = [['unsearch x?', this.unsearch.bind(this,Type,Hash)]]
    this.unsearch (Type,Hash)
    this.setState({ redraw : true })
  }
  onPressTagShadow = (Type, Hash) => {
    delete this.state.popup[ `${Type},${Hash}` ]
    this.setState({ redraw : true })
  }

  computeLetterSectionOffsets = headerHeight => {
    if( this.state.offsets || !this.state.heights.header ) return false
    let len = Object.keys(this.state.heights).length
    if( len -1 !== lettermap.length ) return false
    const offset = letter => this.state.offsets&&this.state.offsets[letter]? this.state.offsets[letter]: 0
        , height = letter => this.state.heights&&this.state.heights[letter]? this.state.heights[letter]: 0
        , calculateOffset = (set, lim) => lim? offset(set[lim-1])+height(set[lim-1]): this.state.heights.header
    var A = Object.keys(this.state.heights).filter(key=>key!=='header')
      , B = lettermap.slice( )

    var Ordering = Order( )
    A = Ordering( A ), B = Ordering( B )
    for( var i = 0 ; i < A.length ; ++ i )
      if( A[i] !== B[i] ) return false

    console.log('letter section heights all appear computed, calculating offsets')
    this.state.offsets = {header:0}
    for( var i = 0; i < A.length ; ++ i )
      this.state.offsets[A[i]] = calculateOffset(A,i)

    console.log(this.state.offsets)
    return true
  }
  scrollTo = letter => {
    let offset = this.state.offsets[letter]
      , scroller = this.brandsScroller
    if( offset && scroller && scroller.state && scroller.state.layoutHeight ) {
        scroller.scrollTo({ x : 0, y : offset, animated : true })
    }
  }


  merchantFilterString = ( ) => this.state.merchants.reduce( (csv, merchant) => csv? csv+`,${merchant.id}`: `${merchant.id}`, false )
  // numSearchTags = ( ) => Object.keys(this.state.tags).reduce( (numTags, tagList) => numTags + this.state.tags[tagList].length, this.state.actualSearch.length > 0? 1: 0 )
  numSearchTags = ( ) => {
    // console.tron.display({name: 'numSearchTags', preview: `details`, value: {stateTags: this.state.tags, actualSearch: this.state.actualSearch}})
    if (typeof this.state.actualSearch == 'undefined')
      return Object.keys(this.state.tags).reduce( (numTags, tagList) => numTags + this.state.tags[tagList].length, 0 )
    return Object.keys(this.state.tags).reduce( (numTags, tagList) => numTags + this.state.tags[tagList].length, this.state.actualSearch.length > 0? 1: 0 )
  }
  mapSearchTags = ( ) => Object.keys(this.state.tags).reduce( (map, key) => { map[key] = this.TagString(key) ; return map }, { } )
  viewSearchTags = ( ) => Object.keys(this.state.tags)
                              .reduce(  (view, key) =>  this.state.tags[key]
                                                        .map  (  Hash =>
                                                                    <Tag  Hash={Hash} popup={this.state.popup[ `${key},${Hash}` ]} Type={key}
                                                                          onPress={this.onPressTypeTag.bind(this,key,Hash)} onShadow={this.onPressTagShadow.bind(this,key,Hash)}/>
                                                              )
                                                        .concat(view)
                                      , this.state.actualSearch
                                        ? [ <Tag  Hash={this.state.actualSearch} popup={this.state.popup[ `search,${this.state.actualSearch}` ]} Type={'search'}
                                                  onPress={this.onPressTypeTag.bind(this,'search',this.state.actualSearch)}
                                                  onShadow={this.onPressTagShadow.bind(this,'search',this.state.actualSearch)}/>
                                          ]
                                        : [ ]
                                      )
  titleSearchTags = ( ) => null

  // "-price,text input string,Brand1,Brand2,Color1,Coupon1,Coupon2"
  // Object.keys(this.state.tags) = [ brands, merchants, categories, colors, sizes, coupons ]
  stateHash = ( ) =>  Object.keys(this.state.tags).reduce( (hash, key) =>
      hash  + (this.state.tags[key].length
        ? ','+this.state.tags[key].join(',')
        : '')
    , this.state.sortHash( )+(this.state.actualSearch && this.state.actualSearch.length > 0 ? ','+this.state.actualSearch : '')
  )
  
  filterShoppableBrands = (list) => {
    console.tron.log(`filterShoppableBrands start, shoppable product count: ` + list.length)
    // console.tron.display({name: 'ExploraShopping', preview: `filterShoppableBrands`, value: {shoppableProp: this.props.shoppable, brandList, list}})
    let brandList = this.props.shoppable.config && this.props.shoppable.config.data ? this.props.shoppable.config.data.brands : []
    if (brandList) {
      try {
        console.tron.log(`filterShoppableBrands brandList count: ` + brandList.length)
        brandList = brandList.map(v => v.toLowerCase())
        let finalList = [] // make a copy...
        list.forEach(function (product) {
          if (product.brand && product.name && product.merchant && product.price)
            if (brandList.indexOf(product.brand.toLowerCase()) >= 0)
              finalList.push(product) // need full product detail when clicking on it
        })
        // const finalList = list.filter(function (v) { return brandList.indexOf(v.brand.toLowerCase()) != -1 })
        console.tron.log(`filterShoppableBrands finalList count: ` + finalList.length)
        return finalList
      }
      catch (e) {
        console.tron.display({
          name: 'filterShoppableBrands',
          preview: "error",
          value: {
            message: e.message,
            e: e
          }
        })
      }
    }
    console.tron.log(`filterShoppableBrands ends`)
    return list
  }


  sendQuery = ( ) => {
    var numSearchTags = this.numSearchTags( )
      , kargoeSearch = this.state.actualSearch.match(/^kargoe-search: (.*)$/)
    // console.tron.display({name: 'ExploraShopping', preview: `sendQuery`, value: {actualSearch: this.state.actualSearch, kargoeSearch}})
    this.setState({ redraw : true, searchText : '', showProducts : true })
    const queries = ( ) =>  ( kargoeSearch /*|| numSearchTags === 1*/ )
                            ? [ this.props.api.itemSearch({ start : 0, limit : maxProductsReturned, search : this.state.actualSearch, filter : 'THEYSELL_ONLY', sort : this.state.sortString }) ]
                            : [ this.props.api.shoppableCatalog(Object.assign({ search : this.state.actualSearch, rows : maxProductsReturned, sort : this.state.sortString, 'merchant_ids' : this.merchantFilterString( ) }, this.mapSearchTags( )))
                              , this.props.api.itemSearch({ start : 0, limit : maxProductsReturned, search : this.state.actualSearch, filter : 'THEYSELL_ONLY', sort : this.state.sortString })
                              ]

    if( kargoeSearch ) this.state.actualSearch = kargoeSearch [1]
    if( Array.isArray(this.state.tags.header) ) {
      console.tron.log(`actualSearch: ${this.state.actualSearch}, change to state.tags.header[0]: ${this.state.tags.header[0]}`)
      this.state.actualSearch = this.state.tags.header[0]
      delete this.state.tags.header
    }
    if( numSearchTags < 1 ) return false

    let stateHash = this.stateHash( )
      , state = this.state.searchCache[stateHash]
    const maxProductsReturned = MaxProductsFromBrandQuery
    // state is a query result
    if(   (state && state.length < maxProductsReturned)  ||  ! state )
        Promise.all (queries ( ))
        .then(responses => {
          console.tron.log(`sendQuery queries finished`)
          var resp = { }, shopify = { }
          if( responses.length === 2 ) {[ resp, shopify ] = responses}
          else {[ shopify ] = responses}
          console.log('shoppable query: ', resp, shopify)
          var allProducts = [ ]
          if( shopify.ok && Array.isArray(shopify.data.data) )
            allProducts = allProducts.concat(shopify.data.data.map(v=>{v.isShopify=true; return v}))
          if( resp.ok && Array.isArray(resp.data.products) ) {
            console.tron.log(`sendQuery got a response back from Shoppable`)
            // allProducts = allProducts.concat(JSON.parse(JSON.stringify(resp.data.products)))
/*            
            const shopifyProductCount = allProducts.length
            const shoppableProducts = JSON.parse(JSON.stringify(resp.data.products))
            const filteredShoppableProducts = this.filterShoppableBrands(shoppableProducts)
            allProducts = allProducts.concat(filteredShoppableProducts)
            console.tron.log("We recieved: " + shopifyProductCount + " shopify, with " + shoppableProducts.length + " total and " + filteredShoppableProducts.length + " filtered products from Shoppable")
*/
            allProducts = allProducts.concat(this.filterShoppableBrands(resp.data.products))
            console.tron.log(`sendQuery merging nav`)
            this.state.searchCache['nav,'+stateHash] = JSON.parse(JSON.stringify(resp.data.navigation))
          }

          this.state.searchCache[stateHash] = allProducts
          if( this.stateHash( ) === stateHash ) { // even though we've waited remote GET time
              this.recycler.data = this.recycler.data.cloneWithRows(allProducts)
              this.setState({ showProducts : true }) // show search result
          }
                        /* Navigation data
                        navigation:
                            brands: (2000) [{…}, {…}, …]
                            categories: (3) [{…}, {…}, {…}]
                            colors: (3) [{…}, {…}, {…}]
                            merchants: (2) [{…}, {…}]
                            next_page_url: "/v3/catalog?brands=BEAR%20CREEK%20SMOKEHOUSE&rows=5&sort=price&offset=5"
                            previous_page_url: ""
                            price_max: 189
                            price_min: 22
                            sizes: [{…}]
                            url: "/v3/catalog?brands=BEAR+CREEK+SMOKEHOUSE&rows=5&sort=price"
                        */
        })
        .catch(console.log)

  }

  addFilter = (Type, Hash) => {
    console.log('add search filter: ', Type, Hash)
    if(!this.state.tags[Type]) this.state.tags[Type]=[Hash]
    else if(this.state.tags[Type].indexOf(Hash) == -1)
      this.state.tags[Type].push(Hash)
    this.sendQuery( )

  }
  showBack = ( ) => this.numSearchTags( ) !== 0
  config = this.props.dataProvider || { }
  headerString = I18n.t("explora.commissionNote")
  headerSuffix = '15%'
  headerDivs = (this.config && this.config.shopifyStores && this.config.trendingShopifyStoreIds && this.config.shopifyStores.filter( ({StoreId}) => this.config.trendingShopifyStoreIds.indexOf(StoreId) !== -1 ).map( ({ StoreId, StoreName }) =>
      <Text onPress={( ) => this.setState({actualSearch:`kargoe-search: ${StoreName}`},this.sendQuery)}>{StoreName}</Text> )) || <View/>
  displayBrands = ( ) => {
    const kargoeSearch = this.state.actualSearch && this.state.actualSearch.match(/^kargoe-search: (.*)$/)
    let displayOffset = this.state.layout.y + this.state.searchBarLayout.h + this.state.searchBarLayout.y
      , stateHash = this.stateHash( )
      , layout = { y : displayOffset, height : h - displayOffset, x : 0, width : w }
      , cache = this.state.searchCache[this.stateHash( )] || false
      , nav = this.state.searchCache['nav,'+this.stateHash( )] || false
      , numSearchTags = this.numSearchTags()
    // console.tron.display({name: 'ExploraShopping', preview: `displayBrands`, value: {numSearchTags, stateHash, showProducts: this.state.showProducts, searchCache: this.state.searchCache}})
    const height = layout.height ? layout.height : 500
    if(numSearchTags > 0 && this.state.showProducts)
      return cache ?
                  <View style={{flex : 1, zIndex : 3, minHeight : height, maxHeight : height, minWidth : layout.width, maxWidth : layout.width}}>
                      <SearchResults
                          viewProduct={ Product => {
                            this.props.navigation
                              .navigate ( 'product'
                                        , { item :  Product.isShopify
                                                        ?   Product
                                                        :   shoppableProductToKargoeItem (this.state.merchants, Product)
                                          }
                                        )
                          }}
                          endorseProduct={ Product => {
                            this.props.endorseIt(Product.isShopify? Product: shoppableProductToKargoeItem(this.state.merchants, Product))
                          }}
                          buyProduct={ Product => {

                            if(Product.isShopify) {
                              this.props.api.orderPreflight ({ PostId : 'express', TagId : Product.ItemId })
                              .then(resp => this.props.navigation.navigate ( 'orderConfirm'
                                                                            , Object.assign({ api : { PostId : 'express', TagId : Product.ItemId }
                                                                                            , tag : false, data : Product, meta : { }
                                                                                            }
                                                                                            , resp.data)))
                              .catch(console.log)
                            } else {
                              // utils.js shoppable to kargoe (f) -> ItemId
                              let shoppableTag = {ItemId:`${Product.part_number}_shop`}
                                , shoppableKargoe = shoppableProductToKargoeItem (this.state.merchants, Product)
                              console.log('buying: ', shoppableKargoe)
                              this.props.navigation.navigate( 'shoppableVariant'
                                                            , { post  :   { PostId    : 'express'
                                                                          , UserId    : null
                                                                          , Username  : 'n/a'
                                                                          , Donate : [ ], ISell : [ ] //, UserTags !??
                                                                          , TheySell  : [ shoppableTag ]
                                                                          }
                                                              , tag   : shoppableTag
                                                              , item  : shoppableKargoe
                                                              }
                                                            )
                            }
                          }}
                          products={cache} nav={nav} layout={layout}
                          DisplayTitle={this.titleSearchTags( )} parent={this}
                          showSortSelector={this.showSortSelector.bind(this)}
                          openSortSelector={this.openSortSelector.bind(this)}
                          closeSortSelector={this.closeSortSelector.bind(this)}
                          kargoeSearch={kargoeSearch}
                          sortOption={this.state.sortOption}
                          sortOptions={kargoeSearch ? this.state.kargoeSortOptions : this.state.sortOptions}/>

                      { this.state.filtering && <View style={{ zIndex : 4, position : 'absolute', left : 5, top : 0, width : w*0.9, height : w }}>
                                                    <TouchableOpacity style={{ ...fullScreen, backgroundColor : '#00000077', zIndex : 1 }}
                                                                      onPress={( ) => this.setState({ filtering : false })} activeOpacity={0.5}/>

                                                    <MapView style={{ zIndex : 2 }}
                                                        letters={this.Letters} letter={this.state.letter} filtering={this.state.filtering}
                                                        focus={this.state.focus} search={this.state.searchText} parent={this} layout={layout}
                                                        setState={this.setState.bind(this)} addFilter={ (type,name) => {
                                                                                                            this.setState({ filtering : false })
                                                                                                            this.addFilter(type,name)
                                                                                                      }}/>
                                                </View>
                      }
                  </View>
                : <View style={{ backgroundColor : 'white', width : '100%', height : '100%', flex : 1, justifyContent : 'center', alignItems : 'center' }}>
                      <View style={{ minWidth: w*0.18, minHeight: w*0.18, maxWidth: w*0.18, maxHeight: w*0.18 }}>
                             <LottieView style={{ width: '100%', height: '100%' }}
                              ref={ spinner => {  if(spinner) {
                                                    this.refs.spinner = spinner
                                                    spinner.play( )
                                                  }}}
                              loop autoPlay source={Images.spinnerDark}/>
                           </View>
                  </View>
    // search={this.state.searchText} // remove brand/company breakdown when typing

    // Display list of brands, alphabetically, and a lookup of letters down the right-side
    return <MapView letters={this.Letters} letter={this.state.letter}
                    focus={this.state.focus} search={``} parent={this}
                    layout={{ y : displayOffset, height : h - displayOffset, x : 0, width : w }}
                    setState={this.setState.bind(this)} addFilter={this.addFilter.bind(this)}/>
  }

  startSearch () {
    this.setState({ actualSearch : this.state.searchText }, ( ) => this.sendQuery( ))
  }

  render ( ) {
    // console.tron.display({name: 'render', preview: "ExploraShopping", value: {state: this.state}})
/*
// Shadow
<TouchableOpacity style={{ ...fullScreen, backgroundColor : '#00000077', zIndex : 5, ...showTextInputClosingShadow }} activeOpacity={0.5}
    onPress={( ) => { if( this.refs.search ) {
                          Keyboard.dismiss( )
                          this.refs.search.blur( )
                    }
    }} />
    
// search back button
    <TouchableOpacity
        activeOpacity={0.5} style={{ display : this.showBack( )?'flex':'none', width : w * 0.1, alignItems : 'center' }}
        onPress={( ) => this.setState({ focus : false, showProducts : !this.state.showProducts })}>
      <SvgBackButton/>
    </TouchableOpacity>
*/
    if( ! this.props.dataProvider ) return <View></View>
    if (this.props.resetTime != this.state.resetTime) {
      console.tron.log(`ExploraShopping render resetTime changed`)
      this.state.resetTime = this.props.resetTime // reset once, resetSearch will force the update...
      this.state.tags = []
      this.state.actualSearch = ''
      this.resetSearch()
    }
    let showTextInputClosingShadow = { display : this.state.textBox?'flex':'none' }
    return  <View style={{ flex : 1 }}
                onLayout={ ({ nativeEvent : { layout }}) => {
                  console.log('explora shopping layout event') // e.g. y 89, h 538
                  console.log(layout)
                  this.state.layout = JSON.parse(JSON.stringify(layout))
                }}>

                <View style={{ flexDirection : 'row', flexWrap : 'nowrap', justifyContent : 'center', alignItems : 'center', zIndex : 7 }}>
                    <ScrollView style={{  maxHeight : w*0.2, borderRadius : 10, borderColor : BaseColor, borderWidth : 1
                                        , backgroundColor : ContrastColor, margin : 5, padding : 5, minHeight : w*0.1, width : w * 0.85 }}>
                        <TouchableOpacity activeOpacity={0.5}
                            style={{  backgroundColor : ContrastColor
                                    , flexDirection : 'row', flexWrap : 'wrap', zIndex : 4, maxWidth : w*0.95
                                    , minHeight : w*0.1, alignItems : 'center', justifyContent : 'flex-start'
                                    , width : w * 0.85
                                    , zIndex : 2}}
                            onLayout={ ({ nativeEvent : { layout }}) => {
                              console.log('search bar layout event')
                              console.log(layout)
                              this.state.searchBarLayout = JSON.parse(JSON.stringify(layout))
                            }}
                            onPress={( ) => { this.refs.search.focus( ) }}>
                                  { this.numSearchTags( ) > 0 && this.viewSearchTags( ) }

                                  <TextInput  ref={'search'} multiline={false} placeholder={I18n.t('explora.searchItems')}
                                              style={TextInputStyle} onFocus={( ) => this.setState({ textBox : true }) } onBlur={( ) => this.setState({ textBox : false }) }
                                              placeholderTextColor={PlaceholderColor}
                                              returnKeyType="go"
                                              onSubmitEditing={this.startSearch}
                                              onChangeText={searchText => this.setState({ searchText })} value={this.state.searchText}/>
                        </TouchableOpacity>
                    </ScrollView>
                </View>
                { this.displayBrands() }
            </View>
  }
}